import {IAngularEvent, IComponentOptions, ILogService, IScope} from "angular";
import {StateService} from "@uirouter/angularjs";
import {ChatService} from "./chat.service";
import {User} from "../model/User";
import {NotificationsService} from "../notifications/notifications.service";
import "./chat.less";
import {Application} from "../model/Application";

interface AssessmentMessage {
    senderEmail: string;
    senderName: string;
    created: string;
    text: string;
}

class ChatController {

    public firebaseDatabasePath: string;

    public messageSending: boolean = false;
    public chatMap: any;
    public chatReadByMap: any = {};
    public messageToSend: string;
    public currentUser: User;
    public application: Application;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $scope: IScope,
                private $state: StateService,
                private firebase: any,
                private $firebaseObject: any,
                private $firebaseArray: any,
                private toaster: any,
                private base64: any,
                private chatService: ChatService,
                private notificationsService: NotificationsService) {
    }

    public $onInit() {
        this.$log.debug("ChatController.$onInit()");

        this.setupFirebase();
        this.$scope.$on("chat:markAsRead", (event: IAngularEvent, args: any) => {
            this.$log.debug(event);
            this.$log.debug(args);
            if (this.firebaseDatabasePath === args.firebaseDatabasePath) {
                this.markAsReadBy(this.currentUser);
            }
        });
    }

    public markAsReadBy(user: User) {
        this.$log.debug("markAsRead()", user.username);

        this.chatReadByMap[user.username] = true;

        this.chatReadByMap.$save()
            .then(() => {
                this.$log.debug("Marked as read by " + user.username);
            })
            .catch((error) => {
                this.$log.error(error);
            });
    }

    public sendMessage(text: string) {
        this.$log.debug("sendMessage()", text);

        if (!text || text.trim().length === 0) {
            return;
        }

        this.messageSending = true;

        this.chatMap.$add({
            senderEmail: this.currentUser.email,
            senderName: `${this.currentUser.givenName} ${this.currentUser.surName}`,
            text: text,
            created: this.firebase.database.ServerValue.TIMESTAMP
        }).then(() => {
            this.messageSending = false;
            this.messageToSend = null;
            this.postNotification(text);
        });

        this.chatReadByMap.$remove();
        this.markAsReadBy(this.currentUser);
    }

    private setupFirebase() {
        const messagesRef = this.firebase.database().ref(this.firebaseDatabasePath);

        if (!this.chatMap) {
            const groupEncoded = this.base64.urlencode(this.chatService.GROUP_CHANNEL_NAME);
            const groupChatRef = messagesRef.child(groupEncoded);
            const groupReadByChatRef = messagesRef.child(groupEncoded + "-readBy");

            this.setupNewMessageNotification(groupChatRef);
            this.chatMap = this.$firebaseArray(groupChatRef);
            this.chatReadByMap = this.$firebaseObject(groupReadByChatRef);
        }
    }

    private setupNewMessageNotification(ref) {
        if (!ref) {
            return;
        }

        this.$log.debug("setupNewMessageNotification", ref.path);

        ref.off(); // Detach old listener

        ref.orderByChild("created").startAt(Date.now()).on("child_added", (data) => {
            const message: AssessmentMessage = data.val();

            if (message.senderEmail !== this.currentUser.email) {
                this.toaster.pop({type: "info", title: "You've got a new message from " + message.senderName});
            }
        });
    }

    private postNotification(text: string) {
        const user = this.currentUser;
        const applicationId = this.application.id;
        const givenName = this.application.applicant.givenName;
        const familyName = this.application.applicant.familyName;

        this.notificationsService.publish({
            originator: user.username,
            applicationId: applicationId,
            givenName: givenName,
            familyName: familyName,
            created: this.firebase.database.ServerValue.TIMESTAMP,
            link: `/staff/assess/${applicationId}`,
            type: "comment",
            data: {
                senderName: `${user.givenName} ${user.surName}`,
                text,
            },
        });
    }
}

export const ChatComponent: IComponentOptions = {
    bindings: {
        firebaseDatabasePath: "<",
        currentUser: "<",
        application: "<"
    },
    controller: ChatController,
    template: require("./chat.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/chat/chat.component.ts